import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconRedoOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M16.896 5.739H11.88c-4.62 0-8.38 3.76-8.38 8.38S7.26 22.5 11.88 22.5s8.381-3.76 8.381-8.381h1.5c0 5.448-4.433 9.881-9.881 9.881C6.433 24 2 19.567 2 14.119c0-5.447 4.433-9.88 9.88-9.88h5.016L13.937 1.28a.75.75 0 0 1 1.06-1.061l4.77 4.77-4.77 4.77a.75.75 0 0 1-1.06-1.061zm.807-1.5v1.5z" /></svg>
);
